export const getProductPageUrl = (url: string) => {
  const firstOrContactParam = url.includes('?') ? '&' : '?';

  return `${url.concat(firstOrContactParam)}is_recommended_product=true`;
};
